@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.linkshare

import com.narbase.letsgo.dto.KmmLong
import com.narbase.letsgo.router.EndPoint

object SetLinkShareRewardSettingActiveEndpoint :
    EndPoint<SetLinkShareRewardSettingActiveEndpoint.Request, SetLinkShareRewardSettingActiveEndpoint.Response>() {
    class Request(
        val settingId: KmmLong,
        val isActive: Boolean,
    )

    class Response(
        val id: KmmLong,
    )
}
